module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h25"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The Birdies Fly Away")])])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "342",
      "src": "images/f00vi-01.jpg",
      "width": "550"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("The birdies fly away, and they come back home.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("The birdies fly away, and they come back home.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Fly away, fly away")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("All the birdies fly away,")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("The birdies fly away, and they come back home.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06e1940b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 63
// module chunks = 0